import React from "react";
import "./index.scss";

const BirdAnimation = () => {
  const getRandomDelay = () => {
    return Math.random() * 4 + 1;
  };

  return (
    <div className="birds-outer-container">
      <div
        className="bird-container bird-container--one"
        style={{ animationDelay: `${getRandomDelay()}s` }}
      >
        <div className="bird bird--one"></div>
      </div>

      <div
        className="bird-container bird-container--two"
        style={{ animationDelay: `${getRandomDelay()}s` }}
      >
        <div className="bird bird--two"></div>
      </div>

      <div
        className="bird-container bird-container--three"
        style={{ animationDelay: `${getRandomDelay()}s` }}
      >
        <div className="bird bird--three"></div>
      </div>

      <div
        className="bird-container bird-container--four"
        style={{ animationDelay: `${getRandomDelay()}s` }}
      >
        <div className="bird bird--four"></div>
      </div>
    </div>
  );
};

export default BirdAnimation;
